module.exports = __webpack_public_path__ + "img/logo.c941a841.png";